import DOMPurify from 'dompurify';

// Unicode bidirectional override and other potentially dangerous control characters

const UNSAFE_UNICODE_RE =
  /[\u200E\u200F\u202A-\u202E\u2066-\u2069\u200B-\u200D\uFEFF]/g;

/**
 * Decodes HTML entities (e.g., &amp; → &, &lt; → <) by leveraging the
 * browser's built-in HTML parser via a DOMParser. The input has already
 * been sanitized by DOMPurify so only entity-encoded plain text remains.
 */
function decodeHtmlEntities(text: string): string {
  const doc = new DOMParser().parseFromString(text, 'text/html');
  return doc.body.textContent ?? '';
}

/**
 * Strips HTML tags and unsafe Unicode control characters from a display name.
 * Uses DOMPurify (already a project dependency) with no allowed tags for
 * robust tag stripping, then decodes HTML entities so plain text like
 * "AT&T" is preserved (DOMPurify encodes & → &amp; in its output).
 */
export function sanitizeName(value: string): string {
  const stripped = DOMPurify.sanitize(value, { ALLOWED_TAGS: [] });
  return decodeHtmlEntities(stripped).replace(UNSAFE_UNICODE_RE, '').trim();
}
